import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Standard shadcn `cn` helper: combine conditional class names and resolve
// conflicting Tailwind utility classes.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
